import { render, staticRenderFns } from "./LeaveForm.vue?vue&type=template&id=bf71317a&scoped=true"
import script from "./LeaveForm.vue?vue&type=script&lang=js"
export * from "./LeaveForm.vue?vue&type=script&lang=js"
import style0 from "./LeaveForm.vue?vue&type=style&index=0&id=bf71317a&prod&lang=css"
import style1 from "./LeaveForm.vue?vue&type=style&index=1&id=bf71317a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf71317a",
  null
  
)

export default component.exports